exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-1e0e0b23]{max-width:100%\n}\n.panels-container[data-v-1e0e0b23]{display:flex;justify-content:center;margin:auto;max-width:100%;padding:92px 12px 12px\n}\n.panels[data-v-1e0e0b23]{flex-grow:1;max-width:50%;padding:12px;width:25%\n}\n.panels .layout .container[data-v-1e0e0b23]{padding:0\n}", ""]);

// exports
